 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime~main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"banner":"banner","cards":"cards","common":"common","accordion":"accordion","caveats":"caveats","content-blocks":"content-blocks","fund-cards":"fund-cards","fund-compare":"fund-compare","fund-press-releases":"fund-press-releases","marketo-form":"marketo-form","cta-banner":"cta-banner","dynamic-cards":"dynamic-cards","image-grid":"image-grid","interactive-content":"interactive-content","tax":"tax","Latest Dividends":"Latest Dividends","literature":"literature","on-page-search":"on-page-search","profile":"profile","role-selector-cards":"role-selector-cards","fund-attribution":"fund-attribution","product-detail-layout":"product-detail-layout","fund-listing":"fund-listing","product-details":"product-details","section-nav":"section-nav","us-index":"us-index","table-with-filters":"table-with-filters","vendor.async.xlsx":"vendor.async.xlsx","article":"article","german-calculator-one-time-investment":"german-calculator-one-time-investment","german-calculator-pension":"german-calculator-pension","german-calculator-savings-plan":"german-calculator-savings-plan","german-calculator-withdrawl-plan":"german-calculator-withdrawl-plan","australia-fund-platforms":"australia-fund-platforms","us-index-allocations":"us-index-allocations","us-index-banner":"us-index-banner","us-index-performance":"us-index-performance","what-happened-last-week":"what-happened-last-week","cpreif-portfolio-tool":"cpreif-portfolio-tool","fixed-income-fine-tuning":"fixed-income-fine-tuning","munimap":"munimap","pcstool":"pcstool","popquiz":"popquiz","cpreif-location-map":"cpreif-location-map","vendor.async.gaugeJS":"vendor.async.gaugeJS","recession-dashboard":"recession-dashboard"}[chunkId]||chunkId) + "-es2015." + {"0":"22c5e792d54b02884d5b","banner":"629e7d65a05019772218","cards":"3fef652431f40acf8ed5","common":"78341f92bef8cda7c7fb","accordion":"ee2e18e921d6f9e581bc","caveats":"c2143135fe54be8de133","content-blocks":"9c7658ef49c8c6f9328f","fund-cards":"eef117692e1239b14cc1","fund-compare":"f9dff162db35a41bb816","fund-press-releases":"5b6f71e1b60450cd9a20","marketo-form":"27a9f3d8e6afd28b4b35","cta-banner":"2a9bcb1694d84ee7028d","dynamic-cards":"d59d2602a4e1822e82a6","image-grid":"0289acf3980cd9519cbe","interactive-content":"8dfd4bb25784e9b9fddf","tax":"2be1cc7fff3ea3f46927","Latest Dividends":"8e0e0c0f298b54a0f399","literature":"8e62ce7cb70653164ced","on-page-search":"56ecc70e4e49b48c8210","profile":"1d18f2625dc69781270f","role-selector-cards":"27c61c6f77bba4ec1495","fund-attribution":"fa6cb1eefb0cbc754087","product-detail-layout":"2bb6ae66b235d85f7e8b","fund-listing":"700cc67e889e0eb79f3a","product-details":"5b3b2489bdab68a635fe","section-nav":"46ffefe8fd3899531cc1","us-index":"edb124fbea20dda36650","table-with-filters":"2a366e81ba8464b9bc24","vendor.async.xlsx":"1c293854145bccbf7452","article":"f38a3ef78a919a178954","german-calculator-one-time-investment":"dbdc972a9137bca02689","german-calculator-pension":"191430cc16d030c788b6","german-calculator-savings-plan":"e070f01a06ac5bfba1c5","german-calculator-withdrawl-plan":"89545a3e2930843ac182","australia-fund-platforms":"1f662ffeaf16df471140","us-index-allocations":"71ed58d9dc295528e6bc","us-index-banner":"cc25fdad34b2c4b4147e","us-index-performance":"07edbd81f1fa176e247e","what-happened-last-week":"b4155530e4bec8de6302","cpreif-portfolio-tool":"9786ec3657ea74d6f418","fixed-income-fine-tuning":"2128c0b07f7f8dcce98e","munimap":"597a04e923bde6f0bea8","pcstool":"a01d3ba305a2d749fcdd","popquiz":"ee3d66cc0ca66cffc804","cpreif-location-map":"714e9fc6ad57cf79a91e","vendor.async.gaugeJS":"ea9e8c90ca4f79ce542e","recession-dashboard":"14ead6f5a1278a57aa43"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
